/* eslint no-fallthrough: 0 */
import router from '../router'
import { getField, updateField as vmfUpdateField } from 'vuex-map-fields';
import getConfigs from '$app/configs'

function chkThenApply (toTest, applyTo, newProp, expr) {
  if (toTest) {
    const val = applyTo[newProp];
    try {
      applyTo[newProp] = expr(toTest) || val;
    } catch (err) {
      applyTo[newProp] = val;
    }
  }
}

function getNumAry (ary) {
  return ary.split(',').reduce((a, el) => {
    const n = Number(el);
    if (!isNaN(n) && n != null) {
      a.push(n);
    }
    return a;
  }, []);
}

function updateUrl (search) {
  if (router.currentRoute.path === '/search') {
    router.push({
      query: {
        ...router.currentRoute.query,
        name: search.model.providerName,
        city: search.model.providerCity,
        zip: search.model.providerZip,
        fromyr: search.model.startYear,
        toyr: search.model.endYear,
        displayStyle: search.displayStyle,
        pgtypes: search.model.programTypes.join(','),
        prtypes: search.model.providerTypes.join(','),
        counties: search.model.counties.join(','),
        coalitions: search.model.coalitions.join(','),
        searchRadius: search.model.searchRadius,
        searchOriginLatitude: search.model.searchOriginLatitude,
        searchOriginLongitude: search.model.searchOriginLongitude,
        searchType: search.searchTypes[search.searchType],
        sort: search.model.currentSort.queryKey
      }
    }).catch(error => {
      if (error.name !== 'NavigationDuplicated') {
        throw error;
      }
    });
  }
}

const searchModelDefaults = (configs) => ({
  currentSort: { title: 'Name - Ascending', shortTitle: 'A-Z', queryKey: 'a-z', sortOptions: { sortField: 'providerName', sortDescending: false } },
  take: configs.pageSize,
  skip: 0,
  providerName: '',
  providerCity: '',
  providerZip: '',
  counties: [],
  coalitions: [],
  startYear: configs.maxYear - 1,
  endYear: configs.maxYear,
  providerTypes: [],
  programTypes: ['1', '2'],
  searchRadius: 0,
  searchOriginLatitude: 0,
  searchOriginLongitude: 0,
  searchOriginAddress: ''
});

export default function(store) {
  const searchModule = {
    namespaced: true,

    // STATE
    state: {
      update: false,
      delayed: false,
      drawerOpen: true,
      searchType: 0,
      searchTypes: ['Standard', 'Advanced'],
      displayStyle: 'cards',
      sortOptions: [{ title: 'Name - Ascending', shortTitle: 'A-Z', queryKey: 'a-z', sortOptions: { sortField: 'providerName', sortDescending: false } }, { title: 'Name - Descending', shortTitle: 'Z-A', queryKey: 'z-a', sortOptions: { sortField: 'providerName', sortDescending: true } }, { title: 'Readiness Rate - Ascending', shortTitle: 'RR \u25b2', queryKey: 'rr', sortOptions: { sortField: 'readinessRate', sortDescending: false } }, { title: 'Readiness Rate - Descending', shortTitle: 'RR \u25bc', queryKey: 'rrdsc', sortOptions: { sortField: 'readinessRate', sortDescending: true } }],
      model: searchModelDefaults(store.state.configs)
    },

    // MUTATIONS
    mutations: {
      updateYears: (state, payload) => {
        state.model.startYear = payload.startYear
        state.model.endYear = payload.endYear
      },
      updateField: (state, payload) => {
        if (payload) {
          switch (payload.path) {
            case 'model.providerName':
            case 'model.providerCity':
            case 'model.providerZip':
            case 'model.searchRadius':
            case 'model.searchOriginLatitude':
            case 'model.searchOriginLongitude':
              state.delayed = true;
            case 'model.counties':
            case 'model.coalitions':
            case 'model.startYear':
            case 'model.endYear':
            case 'model.programTypes':
            case 'model.providerTypes':
            case 'model.currentSort':
              state.update = true;
          }

          if (payload.path === 'searchType' && state.searchType === 1 && payload.value === 0) {
            // reset search fields which are only on 'advanced search'
            const { coalitions, counties, providerCity, providerZip, startYear, endYear } = searchModelDefaults(store.state.configs);
            state.model = { ...state.model, coalitions, counties, providerCity, providerZip, startYear, endYear };
            state.update = true;
          }
          vmfUpdateField(state, payload);
          updateUrl(state);
        }
      },
      update: (state) => {
        state.update = true;
      },
      processed: (state) => {
        state.delayed = false;
        state.update = false;
      },
      updateFromUrl: (state) => {
        if (router.currentRoute && router.currentRoute.query) {
          const query = router.currentRoute.query;
          chkThenApply(query.searchType, state, 'searchType', x => state.searchTypes.indexOf(x));
          chkThenApply(query.sort, state.model, 'currentSort', x => state.sortOptions.find(y => y.queryKey === x));
          chkThenApply(query.displayStyle, state, 'displayStyle', x => x);
          chkThenApply(query.name, state.model, 'providerName', x => x);
          chkThenApply(query.city, state.model, 'providerCity', x => x);
          chkThenApply(query.zip, state.model, 'providerZip', x => x);
          chkThenApply(query.fromyr, state.model, 'startYear', x => Number(x) || store.state.configs.maxYear - 1);
          chkThenApply(query.toyr, state.model, 'endYear', x => Number(x) || store.state.configs.maxYear);
          chkThenApply(query.pgtypes, state.model, 'programTypes', x => x.split(','));
          chkThenApply(query.prtypes, state.model, 'providerTypes', x => getNumAry(x));
          chkThenApply(query.counties, state.model, 'counties', x => getNumAry(x));
          chkThenApply(query.coalitions, state.model, 'coalitions', x => getNumAry(x));
          chkThenApply(query.searchRadius, state.model, 'searchRadius', x => parseInt(x));
          chkThenApply(query.searchOriginLatitude, state.model, 'searchOriginLatitude', x => parseFloat(x));
          chkThenApply(query.searchOriginLongitude, state.model, 'searchOriginLongitude', x => parseFloat(x));
        }
      },
      reset: (state, searchModel) => {
        state.model = searchModel;
      }
    },

    // ACTIONS
    actions: {
      reset: ({ commit }) => {
        getConfigs().then(configs => commit('reset', searchModelDefaults(configs)));
      }
    },

    // GETTERS
    getters: {
      getField
    }
  };

  store.registerModule('search', searchModule);

  store.dispatch('search/reset');
}
